import { render, staticRenderFns } from "./Resources.vue?vue&type=template&id=59fe5692"
import script from "./Resources.vue?vue&type=script&lang=ts"
export * from "./Resources.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports